export class Constants {
  static VERSION = "3.0.8";
  static IONIC_APP_ID = "abcaa60c";
  static PUBLISH_TIPS_MINUTES_BEFORE = 20;
  static Enum_BetItemOption: any;
  static GRID_MENU_DEFAULT_SELECTED_TAB = 1;
  static HORSE_TIP_ADD_TIPS_END_MINUTE = 5;
  static HORSE_PACKAGE_ADD_TIPS_END_MINUTE = 120;
  static FB_ADD_TIPS_END_MINUTE = 5;
  static HORSE_MAX_STRONG_CONFIDENCE_COUNT = 2;

  static STORAGE_KEY_WEB_SOCKET_URL = "websocketUrl";
  static STORAGE_KEY_USER_ID = "userID";
  static STORAGE_KEY_LANG = "lang";
  static STORAGE_KEY_PHONELOGIN_PHONENUMBER = "phonenumber";
  static STORAGE_KEY_PHONELOGIN_PASSWORD = "password";
  static STORAGE_KEY_WEB_SECRET = "webSecret";
  static STORAGE_KEY_REFERRAL_CODE = "referralCode";
  static STORAGE_KEY_REMEMBER_ME = "rememberMe";
  static STORAGE_KEY_FIRST_LAUNCH_FLAG = "firstLaunchFlag";
  static STORAGE_KEY_ROLE = "role";
  static STORAGE_KEY_NICKNAME = "nickname";
  static STORAGE_KEY_GUEST_PHONENUMBER = "guestPhonenumber";
  static STORAGE_KEY_SKIP_HOME_SCREEN_PROMPT = "skipHomescreenPrompt";
  static STORAGE_KEY_RACE_CARDS = "raceCards";
  static STORAGE_KEY_RACE_CARDS_LAST_MODIFIED = "raceCardsLastModified";
  static STORAGE_KEY_UNREAD_NEWS_COUNT = "unreadNewsCount";
  static STORAGE_KEY_FB_TIPS_PACKAGE_SELECTED_MATCH_DAY ="fbTipsPackageSelectedMatchDay";
  static STORAGE_KEY_GRID_MENU_SELECTED_TAB = "gridMenuSelectedTab";
  static STORAGE_KEY_FIRST_CLICK_KINTIPS_INTRO = "firstClickKintipsIntro";
  static STORAGE_KEY_NOTICE = "notice";
  static STORAGE_KEY_READ_TUTORIAL_ALREADY = "readTurtorialAlready"
  static STORAGE_KEY_SHOW_SHOP_MENU = "showShopMenu"
  static STORAGE_KEY_LIST_FB_TIPS_FILTER = "listFbTipsFilter";
  static STORAGE_KEY_LIST_FB_TIPS_PACKAGE_FILTER = "listFbTipsPackageFilter";
  static STORAGE_KEY_LIST_TIPS_PACKAGE_FILTER = "listTipsPackageFilter";
  static STORAGE_KEY_LIST_IN_RACE_TIPS_FILTER = "listInRaceTipsFilter";
  static STORAGE_KEY_FIRST_CLICK_4_CANNOT_POST_TIPS = "firstClick4CannotPostTips";
  static STORAGE_KEY_ENABLE_PREDICTION_VIDEO = "enablePredictionVideo";

  // Language Key
  static LANG_EN = "EN";
  static LANG_ZH_TW = "ZH_TW";
  static LANG_ZH_CN = "ZH_CN";

  static GUEST_ACCOUNT_USERNAME = "KintipsGuest";
  static GUEST_ACCOUNT_PASSWORD = "GuestPwd";
  static ROLE_TIPSTER = "Tipster";
  static ROLE_USER = "User";
  static ROLE_GUEST = "Guest";
  static ENCRYPT_PASSPHASE = "KintipsSecretPassphase";

  static CREDIT_CARD_TYPE_PAGE = "CreditCardTypePage";


  static ICO_STAR_SVG = "./assets/img/article/ico-star.svg";
  static ICO_BOX2_SVG = "./assets/img/article/ico-box-2.svg";
  static ICO_BOX3_SVG = "./assets/img/article/ico-box-3.svg";
  static ICO_BOX4_SVG = "./assets/img/article/ico-box-4.svg";
  static ICO_PLUS = "./assets/img/article/ico-plus.svg";
  static ICO_AT = "./assets/img/article/ico-at.svg";
  static ICO_EXTENSION = "./assets/img/article/ico-extension.svg";
  static ICO_FAV_PINK = "./assets/img/article/ico-heart-red.svg";
  static ICO_FAV_YELLOW = "./assets/img/article/ico-heart-yellow.svg";
  static ICO_FAV_BLUE = "./assets/img/article/ico-heart-green.svg";
  static ICO_ARROW_UP = "./assets/img/article/ico-arrow-up.svg";
  static ICO_ARROW_DOWN = "./assets/img/article/ico-arrow-down.svg";
  static ICO_STAR_HIDE_SVG = "./assets/img/article/ico-star-hide.svg";
  static ICO_BOX2_HIDE_SVG = "./assets/img/article/ico-box-2-hide.svg";
  static ICO_BOX3_HIDE_SVG = "./assets/img/article/ico-box-3-hide.svg";
  static ICO_BOX4_HIDE_SVG = "./assets/img/article/ico-box-4-hide.svg";
  static ICO_PLUS_HIDE = "./assets/img/article/ico-plus-hide.svg";
  static ICO_AT_HIDE = "./assets/img/article/ico-at-hide.svg";
  static ICO_EXTENSION_HIDE = "./assets/img/article/ico-extension-hide.svg";
  static ICO_ARROW_UP_HIDE = "./assets/img/article/ico-arrow-up-hide.svg";
  static ICO_ARROW_DOWN_HIDE = "./assets/img/article/ico-arrow-down-hide.svg";
  static ICO_R1 = "./assets/img/article/R1.svg";
  static ICO_R2 = "./assets/img/article/R2.svg";
  static ICO_R3 = "./assets/img/article/R3.svg";
  static ICO_R4 = "./assets/img/article/R4.svg";
  static ICO_R5 = "./assets/img/article/R5.svg";
  static ICO_R6 = "./assets/img/article/R6.svg";
  static ICO_R7 = "./assets/img/article/R7.svg";
  static ICO_R8 = "./assets/img/article/R8.svg";
  static ICO_R9 = "./assets/img/article/R9.svg";
  static ICO_R10 = "./assets/img/article/R10.svg";
  static IMG_EMPTY = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

  static Enum_ImageType = ["Profile", "TipsComment", "RaceComment", "TipsPackageComment", "MatchComment", "FbTip", "TipsPackageNote", "FbPackageComment", "", "", "", "Tips", "TipsPackage","","","TipsPackageImage1","TipsPackageImage2","TipsPackageImage3"];
  static Enum_MsgType = ["Comment", "Announcement"];
  //static Enum_BetType = ["主客和", "半場主客和", "讓球主客和", "讓球", "入球大細", "半場入球大細", "角球大細"];
  //static Enum_BetItemOption = ["none", "大", "細", "主", "和", "客"];
  static Enum_Price = [0, 10, 30, 50, 100, 200, 300, 500];

  static CLIENT_ERROR_CODE_ACCESS_DENIED = "ce100001";
  static CLIENT_ERROR_CODE_TIMEOUT = "ce100002";
  static CLIENT_ERROR_CODE_INVALID_RESPONSE = "ce100003";
  static CLIENT_ERROR_CODE_ERROR_RESPONSE = "ce100004";
  static CLIENT_ERROR_CODE_INVALID_MAPPING = "ce100005";
  static CLIENT_ERROR_CODE_WEB_SOCKET_NOT_READY = "ce100006";
  static CLIENT_ERROR_CODE_WEB_SOCKET_URL_INVALID = "ce100007";

  static CLIENT_ERROR_CODE_UNABLE_2_POST_TIPS = "700007";

  static ONE_MINUTE = 1000 * 60;
  static REFRESH_INTERVAL = Constants.ONE_MINUTE * 5;

  static GOOGLE_PLAY_IN_APP_PURCHASE_METHOD = 26;
  static APPLE_IN_APP_PURCHASE_METHOD = 27;

  static DEFAULT_TOPIC_ID = -99;

  static TIPSTER_SCORE_WITH_EXPERT_CAP = 25;

  static MIN_NUM_OF_SELECTED_HORSE = 2;
  static MAX_NUM_OF_SELECTED_HORSE_FOR_LESS_THEN_SIX_HORSES_RACE = 3;

  static LOADING_CTRL_CODE_LOGIN = -1;
  static LOADING_CTRL_CODE_GET_IMAGE = -2;
  static LOADING_GRID_MENU = -3;
  static LOADING_ACCESS_DENIED = -4;
  static LOADING_PAYMENT = -5;

  static KINTIPS_YOUTUBE_CHANNEL = "http://www.youtube.com/channel/UCldOUdGzepTISHxwthxaaCw?sub_confirmation=1";

  static WS_CODE_GET_ACTIVITY_REQUEST = 0;
  static WS_CODE_GET_ACTIVITY_RESPONSE = 1;
  static WS_CODE_BANK_IN_REQUEST = 2;
  static WS_CODE_BANK_IN_RESPONSE = 3;
  static WS_CODE_REG_NOTIFICATION_REQUEST = 4;
  static WS_CODE_REG_NOTIFICATION_RESPONSE = 5;
  static WS_CODE_GET_RACES_REQUEST = 6;
  static WS_CODE_GET_RACES_RESPONSE = 7;
  static WS_CODE_ADD_RACE_COMMENT_REQUEST = 8;
  static WS_CODE_ADD_RACE_COMMENT_RESPONSE = 9;
  static WS_CODE_GET_RACE_COMMENT_REQUEST = 10;
  static WS_CODE_GET_RACE_COMMENT_RESPONSE = 11;
  static WS_CODE_REDEEM_TOKEN_REQUEST = 12;
  static WS_CODE_REDEEM_TOKEN_RESPONSE = 13;
  static WS_CODE_GET_ACTIVATION_CODE_REQUEST = 14;
  static WS_CODE_GET_ACTIVATION_CODE_RESPONSE = 15;
  static WS_CODE_VERIFY_ACTIVATION_CODE_REQUEST = 16;
  static WS_CODE_VERIFY_ACTIVATION_CODE_RESPONSE = 17;
  static WS_CODE_ADD_RACE_TIPS_REQUEST = 18;
  static WS_CODE_ADD_RACE_TIPS_RESPONSE = 19;
  static WS_CODE_EDIT_RACE_TIPS_REQUEST = 20;
  static WS_CODE_EDIT_RACE_TIPS_RESPONSE = 21;
  static WS_CODE_GET_RACE_TIPS_REQUEST = 22;
  static WS_CODE_GET_RACE_TIPS_RESPONSE = 23;
  static WS_CODE_GET_ADD_TIPS_COMMENT_REQUEST = 24;
  static WS_CODE_GET_ADD_TIPS_COMMENT_RESPONSE = 25;
  static WS_CODE_GET_GET_TIPS_COMMENT_REQUEST = 26;
  static WS_CODE_GET_GET_TIPS_COMMENT_RESPONSE = 27;
  static WS_CODE_GET_PUBLISH_TIPS_REQUEST = 28;
  static WS_CODE_GET_PUBLISH_TIPS_RESPONSE = 29;
  static WS_CODE_GET_BUY_TIPS_REQUEST = 30;
  static WS_CODE_GET_BUY_TIPS_RESPONSE = 31;
  static WS_CODE_GET_SUBSCRIBE_TIPSTER_REQUEST = 32;
  static WS_CODE_GET_SUBSCRIBE_TIPSTER_RESPONSE = 33;
  static WS_CODE_GET_BLOCK_TIPSTER_USER_REQUEST = 34;
  static WS_CODE_GET_BLOCK_TIPSTER_USER_RESPONSE = 35;
  static WS_CODE_GET_TIPSTER_SUBSCRIBED_REQUEST = 36;
  static WS_CODE_GET_TIPSTER_SUBSCRIBED_RESPONSE = 37;
  static WS_CODE_GET_TIPSTER_SUBSCRIBER_REQUEST = 38;
  static WS_CODE_GET_TIPSTER_SUBSCRIBER_RESPONSE = 39;
  static WS_CODE_GET_TIPSTER_BLOCKED_REQUEST = 40;
  static WS_CODE_GET_TIPSTER_BLOCKED_RESPONSE = 41;
  static WS_CODE_USER_LIST_REQUEST = 42;
  static WS_CODE_USER_LIST_RESPONSE = 43;
  static WS_CODE_GET_TIPSTER_INFO_REQUEST = 44;
  static WS_CODE_GET_TIPSTER_INFO_RESPONSE = 45;
  static WS_CODE_UPDATE_TIPSTER_PRICE_REQUEST = 46;
  static WS_CODE_UPDATE_TIPSTER_PRICE_RESPONSE = 47;
  static WS_CODE_GET_TIPSTER_LATEST_RESULT_REQUEST = 48;
  static WS_CODE_GET_TIPSTER_LATEST_RESULT_RESPONSE = 49;
  static WS_CODE_ADD_TOKEN_BY_TOKEN_CARD_REQUEST = 50;
  static WS_CODE_ADD_TOKEN_BY_TOKEN_CARD_RESPONSE = 51;
  static WS_CODE_GET_TRANSACTIONS_REQUEST = 52;
  static WS_CODE_GET_TRANSACTIONS_RESPONSE = 53;
  static WS_CODE_REG_USER_REQUEST = 54;
  static WS_CODE_REG_USER_RESPONSE = 55;
  static WS_CODE_GET_USER_REQUEST = 56;
  static WS_CODE_GET_USER_RESPONSE = 57;
  static WS_CODE_UPDATE_USER_REQUEST = 58;
  static WS_CODE_UPDATE_USER_RESPONSE = 59;
  static WS_CODE_RESET_USER_PASSWORD_REQUEST = 60;
  static WS_CODE_RESET_USER_PASSWORD_RESPONSE = 61;
  static WS_CODE_LOGOUT_REQUEST = 62;
  static WS_CODE_LOGOUT_RESPONSE = 63;
  static WS_CODE_ACK_CODE = 64;
  static WS_CODE_GET_DISCUSSION_POSTS_REQUEST = 65;
  static WS_CODE_GET_DISCUSSION_POSTS_RESPONSE = 66;
  static WS_CODE_ADD_DISCUSSION_POST_REQUEST = 67;
  static WS_CODE_ADD_DISCUSSION_POST_RESPONSE = 68;
  static WS_CODE_ADD_RACING_NOTE_REQUEST = 69;
  static WS_CODE_ADD_RACING_NOTE_RESPONSE = 70;
  static WS_CODE_UPDATE_RACING_NOTE_REQUEST = 71;
  static WS_CODE_UPDATE_RACING_NOTE_RESPONSE = 72;
  static WS_CODE_DELETE_RACING_NOTE_REQUEST = 73;
  static WS_CODE_DELETE_RACING_NOTE_RESPONSE = 74;
  static WS_CODE_GET_ALL_HORSE_RACING_NOTES_REQUEST = 75;
  static WS_CODE_GET_ALL_HORSE_RACING_NOTES_RESPONSE = 76;
  static WS_CODE_GET_HORSE_RACING_NOTE_REQUEST = 77;
  static WS_CODE_GET_HORSE_RACING_NOTE_RESPONSE = 78;
  static WS_CODE_USE_REFERRAL_CODE_REQUEST = 79;
  static WS_CODE_USE_REFERRAL_CODE_RESPONSE = 80;
  static WS_CODE_GET_IMAGE_REQUEST = 81;
  static WS_CODE_GET_IMAGE_RESPONSE = 82;
  static WS_CODE_ADD_VERIFY_TIPSTER_REQUEST = 83;
  static WS_CODE_ADD_VERIFY_TIPSTER_RESPONSE = 84;
  static WS_CODE_GET_VERIFY_TIPSTER_STATUS_REQUEST = 85;
  static WS_CODE_GET_VERIFY_TIPSTER_STATUS_RESPONSE = 86;
  static WS_CODE_GET_REDEEM_TOKEN_STATUS_REQUEST = 87;
  static WS_CODE_GET_REDEEM_TOKEN_STATUS_RESPONSE = 88;
  static WS_CODE_GET_BANK_IN_STATUS_REQUEST = 89;
  static WS_CODE_GET_BANK_IN_STATUS_RESPONSE = 90;
  static WS_CODE_GET_HOT_NEWS_REQUEST = 91;
  static WS_CODE_GET_HOT_NEWS_RESPONSE = 92;
  static WS_CODE_GET_PERSONAL_TIPS_REQUEST = 93;
  static WS_CODE_GET_PERSONAL_TIPS_RESPONSE = 94;
  static WS_CODE_GET_RACE_DAY_INFO_REQUEST = 95;
  static WS_CODE_GET_RACE_DAY_INFO_RESPONSE = 96;
  static WS_CODE_BROADCAST_DISCUSSION = 97;
  static WS_CODE_BROADCAST_HOT_NEWS = 98;
  static WS_CODE_BROADCAST_PERSONAL_TIPS = 99;
  static WS_CODE_BROADCAST_RACE_STARTED = 100;
  static WS_CODE_BROADCAST_RACE_ENDED = 101;
  static WS_CODE_ACCESS_DENIED = 102;
  static WS_CODE_UPDATE_USER_BIOGRAPHY_REQUEST = 103;
  static WS_CODE_UPDATE_USER_BIOGRAPHY_RESPONSE = 104;
  static WS_CODE_IN_APP_PURHCASE_REQUEST = 105;
  static WS_CODE_IN_APP_PURCHASE_RESPONSE = 106;
  static WS_CODE_UPDATE_NOTIFICATION_PREFERENCE_REQUEST = 107;
  static WS_CODE_UPDATE_NOTIFICATION_PREFERENCE_RESPONSE = 108;
  static WS_CODE_BLOCK_RACE_COMMENT_REQUEST = 109;
  static WS_CODE_BLOCK_RACE_COMMENT_RESPONSE = 110;
  static WS_CODE_BROADCAST_BLOCK_RACE_COMMENT = 111;
  static WS_CODE_BUY_TIPS_BY_IAP_REQUEST = 112;
  static WS_CODE_BUY_TIPS_BY_IAP_RESPONSE = 113;
  static WS_CODE_CHECK_TIPS_PURCHASED_REQUEST = 114;
  static WS_CODE_CHECK_TIPS_PURCHASED_RESPONSE = 115;
  static WS_CODE_CREATE_PACKAGE_TIPS_REQUEST = 116;
  static WS_CODE_CREATE_PACKAGE_TIPS_RESPONSE = 117;
  static WS_CODE_PUBLISH_PACKAGE_TIPS_REQUEST = 118;
  static WS_CODE_PUBLISH_PACKAGE_TIPS_RESPONSE = 119;
  static WS_CODE_GET_PACKAGE_TIPS_REQUEST = 120;
  static WS_CODE_GET_PACKAGE_TIPS_RESPONSE = 121;
  static WS_CODE_GET_LATEST_PACKAGE_TIPS_REQUEST = 122;
  static WS_CODE_GET_LATEST_PACKAGE_TIPS_RESPONSE = 123;
  static WS_CODE_EDIT_PACKAGE_TIPS_REQUEST = 124;
  static WS_CODE_EDIT_PACKAGE_TIPS_RESPONSE = 125;
  static WS_CODE_BROADCAST_TIPS_PACKAGE_COMMENT = 126;// horse package --- no horse tips
  static WS_CODE_PING_REQUEST = 127;
  static WS_CODE_PING_RESPONSE = 128;

  static WS_CODE_GET_CREDIT_CARD_INFO_REQUEST = 131;
  static WS_CODE_GET_CREDIT_CARD_INFO_RESPONSE = 132;
  static WS_CODE_DELETE_CREDIT_CARD_REQUEST = 133;
  static WS_CODE_DELETE_CREDIT_CARD_RESPONSE = 134;
  static WS_CODE_GET_MATCH_REQUEST = 135;
  static WS_CODE_GET_MATCH_RESPONSE = 136;
  static WS_CODE_GET_FB_TIPSTERS_REQUEST = 137;
  static WS_CODE_GET_FB_TIPSTERS_RESPONSE = 138;
  static WS_CODE_ADD_FB_COMMENT_REQUEST = 139;
  static WS_CODE_ADD_FB_COMMENT_RESPONSE = 140;
  static WS_CODE_GET_FB_COMMENT_REQUEST = 141;
  static WS_CODE_GET_FB_COMMENT_RESPONSE = 142;
  static WS_CODE_BROADCAST_FB_COMMENT = 143;
  static WS_CODE_BROADCAST_BLOCKED_FB_COMMENT = 144;
  static WS_CODE_BLOCK_FB_COMMENT_REQUEST = 145;
  static WS_CODE_BLOCK_FB_COMMENT_RESPONSE = 146;
  static WS_CODE_GET_FB_MATCH_DETAIL_REQUEST = 147;
  static WS_CODE_GET_FB_MATCH_DETAIL_RESPONSE = 148;
  static WS_CODE_ADD_FB_TIPS_REQUEST = 149;
  static WS_CODE_ADD_FB_TIPS_RESPONSE = 150;
  static WS_CODE_GET_FB_PERSONAL_TIPS_REQUEST = 151;
  static WS_CODE_GET_FB_PERSONAL_TIPS_RESPONSE = 152;
  static WS_CODE_BUY_FB_TIPS_REQUEST = 153;
  static WS_CODE_BUY_FB_TIPS_RESPONSE = 154;
  static WS_CODE_ADD_FB_TIPS_COMMENT_REQUEST = 155;
  static WS_CODE_ADD_FB_TIPS_COMMENT_RESPONSE = 156;
  static WS_CODE_GET_FB_TIPS_COMMENT_REQUEST = 157;
  static WS_CODE_GET_FB_TIPS_COMMENT_RESPONSE = 158;
  static WS_CODE_BROADCAST_FB_TIPS_COMMENT = 159;
  static WS_CODE_GET_FB_TIPSTER_LATEST_RESULT_REQUEST = 160;
  static WS_CODE_GET_FB_TIPSTER_LATEST_RESULT_RESPONSE = 161;
  static WS_CODE_GET_FB_TIPSTER_INFO_REQUEST = 162;
  static WS_CODE_GET_FB_TIPSTER_INFO_RESPONSE = 163;
  static WS_CODE_ADD_FAVOURITE_REQUEST = 164;
  static WS_CODE_ADD_FAVOURITE_RESPONSE = 165;
  static WS_CODE_GET_FAVOURITE_REQUEST = 166;
  static WS_CODE_GET_FAVOURITE_RESPONSE = 167;
  static WS_CODE_GET_BET_AMOUNT_QUOTA_REQUEST = 168;
  static WS_CODE_GET_BET_AMOUNT_QUOTA_RESPONSE = 169;
  static WS_CODE_GET_FB_TIPS_DETAILS_REQUEST = 170;
  static WS_CODE_GET_FB_TIPS_DETAILS_RESPONSE = 171;
  static WS_CODE_SUBSCRIBE_FB_TIPSTER_REQUEST = 172;
  static WS_CODE_SUBSCRIBE_FB_TIPSTER_RESPONSE = 173;
  static WS_CODE_GET_FB_TRANSACTIONS_REQUEST = 174;
  static WS_CODE_GET_FB_TRANSACTIONS_RESPONSE = 175;
  static WS_CODE_GET_FB_ACTIVITIES_REQUEST = 176;
  static WS_CODE_GET_FB_ACTIVITIES_RESPONSE = 177;
  static WS_CODE_GET_TIPS_PACKAGE_DETAILS_REQUEST = 178;
  static WS_CODE_GET_TIPS_PACKAGE_DETAILS_RESPONSE = 179;
  static WS_CODE_UPDATE_TIPS_PACKAGE_PRICE_REQUEST = 180;
  static WS_CODE_UPDATE_TIPS_PACKAGE_PRICE_RESPONSE = 181;
  static WS_CODE_BUY_TIPS_PACKAGE_REQUEST = 182;
  static WS_CODE_BUY_TIPS_PACKAGE_RESPONSE = 183;
  static WS_CODE_GET_RACE_HORSE_NOTES_REQUEST = 184;
  static WS_CODE_GET_RACE_HORSE_NOTES_RESPONSE = 185;
  static WS_CODE_ADD_FB_TIPS_PACKAGE_NOTES_REQUEST = 186;
  static WS_CODE_ADD_FB_TIPS_PACKAGE_NOTES_RESPONSE = 187;
  static WS_CODE_BROADCAST_TIPS_COMMENT = 188;
  static WS_CODE_GET_NEW_BUY_TIPS_REQUEST = 189;
  static WS_CODE_GET_NEW_BUY_TIPS_RESPONSE = 190;
  static WS_CODE_NOTIFY_BUYERS_TIPS_PACKAGE_UPDATED_REQUEST = 191;
  static WS_CODE_NOTIFY_BUYERS_TIPS_PACKAGE_UPDATED_RESPONSE = 192;
  static WS_CODE_BROADCAST_HORSE_TIPS_REMINDER = 193;
  static WS_CODE_QUERY_UNION_PAY_REQUEST = 194;
  static WS_CODE_QUERY_UNION_PAY_RESPONSE = 195;
  static WS_CODE_NOTIFY_BUYERS_FB_TIPS_PACKAGE_UPDATED_REQUEST = 196;
  static WS_CODE_NOTIFY_BUYERS_FB_TIPS_PACKAGE_UPDATED_RESPONSE = 197;
  static WS_CODE_CLAIM_REWARD_REQUEST = 198;
  static WS_CODE_CLAIM_REWARD_RESPONSE = 199;
  static WS_CODE_BROADCAST_RADIO = 212;
  static WS_CODE_LOG_LIVE_STREAMING_REQUEST = 217;
  static WS_CODE_LOG_LIVE_STREAMING_RESPONSE = 218;
  static WS_CODE_GET_VIDEO_INFO_REQUEST = 231;
  static WS_CODE_GET_VIDEO_INFO_RESPONSE = 232;
  static WS_CODE_FB_GET_VIDEO_INFO_REQUEST = 234;
  static WS_CODE_FB_GET_VIDEO_INFO_RESPONSE = 235;
  static WS_CODE_BROADCAST_RECEIVE_VOUCHER = 259;
  static WS_CODE_GET_TIPSTER_ARTICLE_REQUEST = 269;
  static WS_CODE_GET_TIPSTER_ARTICLE_RESPONSE = 270;
  static WS_CODE_GET_ARTICLE_DETAILS_REQUEST = 271;
  static WS_CODE_GET_ARTICLE_DETAILS_RESPONSE = 272;
  static WS_CODE_GET_BF_TIPSTER_ARTICLE_REQUEST = 267;
  static WS_CODE_GET_BF_TIPSTER_ARTICLE_RESPONSE = 268;
  static WS_CODE_GET_ALL_ARTICLE_DETAILS_REQUEST = 269;
  static WS_CODE_GET_ALL_ARTICLE_DETAILS_RESPONSE = 270;
  static WS_CODE_UPDATE_ANALYSIS = 273;
  static WS_CODE_GET_VIDEO_AND_ARTICLE_RESPONSE = 275;
  static WS_CODE_GET_VIDEO_AND_ARTICLE_REQUEST = 274;
  static WS_CODE_GET_SPEED_ARTICLE_REQUEST = 290;
  static WS_CODE_GET_SPEED_ARTICLE_RESPONSE = 291;
  static WS_CODE_QUERY_VISA_MASTER_REQUEST = 314;
  static WS_CODE_QUERY_VISA_MASTER_RESPONSE = 315;

  static WS_CODE_DISABLE_ACCOUNT_REQUEST = 318;
  static WS_CODE_DISABLE_ACCOUNT_RESPONSE = 319;

  static LANG_NAME = Constants.LANG_ZH_TW;
  static LANG_NAME_FULL_STOP = "\'。\'";

  static WS_CODES_KEY_MAP = {
    [Constants.WS_CODE_GET_ACTIVITY_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_GET_ACTIVITY_RESPONSE]: "ActivityList",
    [Constants.WS_CODE_BANK_IN_REQUEST]: "BankInReqInfo",
    [Constants.WS_CODE_BANK_IN_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_REG_NOTIFICATION_REQUEST]: "RegNotificationReqInfo",
    [Constants.WS_CODE_REG_NOTIFICATION_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_RACES_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_GET_RACES_RESPONSE]: "RaceCards",
    [Constants.WS_CODE_ADD_RACE_COMMENT_REQUEST]: "Comment",
    [Constants.WS_CODE_ADD_RACE_COMMENT_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_RACE_COMMENT_REQUEST]: "RaceCard",
    [Constants.WS_CODE_GET_RACE_COMMENT_RESPONSE]: "Comments",
    [Constants.WS_CODE_REDEEM_TOKEN_REQUEST]: "RedeemTokenReqInfo",
    [Constants.WS_CODE_REDEEM_TOKEN_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_ACTIVATION_CODE_REQUEST]: "ActivationReqInfo",
    [Constants.WS_CODE_GET_ACTIVATION_CODE_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_VERIFY_ACTIVATION_CODE_REQUEST]: "VerifyActivationCodeReqInfo",
    [Constants.WS_CODE_VERIFY_ACTIVATION_CODE_RESPONSE]: "VerifyActivationCodeRespInfo",
    [Constants.WS_CODE_ADD_RACE_TIPS_REQUEST]: "RaceTip",
    [Constants.WS_CODE_ADD_RACE_TIPS_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_EDIT_RACE_TIPS_REQUEST]: "RaceTip",
    [Constants.WS_CODE_EDIT_RACE_TIPS_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_RACE_TIPS_REQUEST]: "RaceTip",
    [Constants.WS_CODE_GET_RACE_TIPS_RESPONSE]: "RaceCard",
    [Constants.WS_CODE_GET_ADD_TIPS_COMMENT_REQUEST]: "Comment",
    [Constants.WS_CODE_GET_ADD_TIPS_COMMENT_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_GET_TIPS_COMMENT_REQUEST]: "RaceTip",
    [Constants.WS_CODE_GET_GET_TIPS_COMMENT_RESPONSE]: "Comments",
    [Constants.WS_CODE_GET_PUBLISH_TIPS_REQUEST]: "RaceTip",
    [Constants.WS_CODE_GET_PUBLISH_TIPS_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_BUY_TIPS_REQUEST]: "RaceTip",
    [Constants.WS_CODE_GET_BUY_TIPS_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_SUBSCRIBE_TIPSTER_REQUEST]: "TipsterSubscribeReqInfo",
    [Constants.WS_CODE_GET_SUBSCRIBE_TIPSTER_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_BLOCK_TIPSTER_USER_REQUEST]: "BlockUserReqInfo",
    [Constants.WS_CODE_GET_BLOCK_TIPSTER_USER_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_TIPSTER_SUBSCRIBED_REQUEST]: "GetTipsterSubscribedReqInfo",
    [Constants.WS_CODE_GET_TIPSTER_SUBSCRIBED_RESPONSE]: "Tipsters",
    [Constants.WS_CODE_GET_TIPSTER_SUBSCRIBER_REQUEST]: "GetTipsterSubscribedReqInfo",
    [Constants.WS_CODE_GET_TIPSTER_SUBSCRIBER_RESPONSE]: "Tipsters",
    [Constants.WS_CODE_GET_TIPSTER_BLOCKED_REQUEST]: "UserProfile",
    [Constants.WS_CODE_GET_TIPSTER_BLOCKED_RESPONSE]: "Tipsters",
    [Constants.WS_CODE_USER_LIST_REQUEST]: "UserProfile",
    [Constants.WS_CODE_USER_LIST_RESPONSE]: "Tipsters",
    [Constants.WS_CODE_GET_TIPSTER_INFO_REQUEST]: "TipsterInfo",
    [Constants.WS_CODE_GET_TIPSTER_INFO_RESPONSE]: "TipsterInfo",
    [Constants.WS_CODE_UPDATE_TIPSTER_PRICE_REQUEST]: "TipsterInfo",
    [Constants.WS_CODE_UPDATE_TIPSTER_PRICE_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_TIPSTER_LATEST_RESULT_REQUEST]: "TipsterInfo",
    [Constants.WS_CODE_GET_TIPSTER_LATEST_RESULT_RESPONSE]: "RaceCards",
    [Constants.WS_CODE_ADD_TOKEN_BY_TOKEN_CARD_REQUEST]: "AddTokenCardReqInfo",
    [Constants.WS_CODE_ADD_TOKEN_BY_TOKEN_CARD_RESPONSE]: "AddTokenCardRespInfo",
    [Constants.WS_CODE_GET_TRANSACTIONS_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_GET_TRANSACTIONS_RESPONSE]: "Transactions",
    [Constants.WS_CODE_REG_USER_REQUEST]: "RegUserReqInfo",
    [Constants.WS_CODE_REG_USER_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_USER_REQUEST]: "UserProfile",
    [Constants.WS_CODE_GET_USER_RESPONSE]: "UserProfile",
    [Constants.WS_CODE_UPDATE_USER_REQUEST]: "UserProfile",
    [Constants.WS_CODE_UPDATE_USER_RESPONSE]: "UserProfile",
    [Constants.WS_CODE_RESET_USER_PASSWORD_REQUEST]: "UserProfile",
    [Constants.WS_CODE_RESET_USER_PASSWORD_RESPONSE]: "UserProfile",
    [Constants.WS_CODE_LOGOUT_REQUEST]: "UserProfile",
    [Constants.WS_CODE_LOGOUT_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_ACK_CODE]: "Acknowledge",
    [Constants.WS_CODE_GET_DISCUSSION_POSTS_REQUEST]: "Comment",
    [Constants.WS_CODE_GET_DISCUSSION_POSTS_RESPONSE]: "Comments",
    [Constants.WS_CODE_ADD_DISCUSSION_POST_REQUEST]: "Comment",
    [Constants.WS_CODE_ADD_DISCUSSION_POST_RESPONSE]: "Comment",
    [Constants.WS_CODE_ADD_RACING_NOTE_REQUEST]: "RacingNote",
    [Constants.WS_CODE_ADD_RACING_NOTE_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_UPDATE_RACING_NOTE_REQUEST]: "RacingNote",
    [Constants.WS_CODE_UPDATE_RACING_NOTE_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_DELETE_RACING_NOTE_REQUEST]: "RacingNote",
    [Constants.WS_CODE_DELETE_RACING_NOTE_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_ALL_HORSE_RACING_NOTES_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_GET_ALL_HORSE_RACING_NOTES_RESPONSE]: "HorseRacingNotes",
    [Constants.WS_CODE_GET_HORSE_RACING_NOTE_REQUEST]: "HorseRacingNote",
    [Constants.WS_CODE_GET_HORSE_RACING_NOTE_RESPONSE]: "HorseRacingNote",
    [Constants.WS_CODE_USE_REFERRAL_CODE_REQUEST]: "UseReferralCodeReqInfo",
    [Constants.WS_CODE_USE_REFERRAL_CODE_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_IMAGE_REQUEST]: "Image",
    [Constants.WS_CODE_GET_IMAGE_RESPONSE]: "Image",
    [Constants.WS_CODE_ADD_VERIFY_TIPSTER_REQUEST]: "VerifyTipsterReqInfo",
    [Constants.WS_CODE_ADD_VERIFY_TIPSTER_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_VERIFY_TIPSTER_STATUS_REQUEST]: "VerifyTipsterReqInfo",
    [Constants.WS_CODE_GET_VERIFY_TIPSTER_STATUS_RESPONSE]: "VerifyTipsterReqInfo",
    [Constants.WS_CODE_GET_REDEEM_TOKEN_STATUS_REQUEST]: "RedeemTokenReqInfo",
    [Constants.WS_CODE_GET_REDEEM_TOKEN_STATUS_RESPONSE]: "RedeemTokenReqInfo",
    [Constants.WS_CODE_GET_BANK_IN_STATUS_REQUEST]: "BankInReqInfo",
    [Constants.WS_CODE_GET_BANK_IN_STATUS_RESPONSE]: "BankInReqInfo",
    [Constants.WS_CODE_GET_HOT_NEWS_REQUEST]: "RaceDayReqInfo",
    [Constants.WS_CODE_GET_HOT_NEWS_RESPONSE]: "HotNewsList",
    [Constants.WS_CODE_GET_PERSONAL_TIPS_REQUEST]: "RaceDayReqInfo",
    [Constants.WS_CODE_GET_PERSONAL_TIPS_RESPONSE]: "PersonalRaceTips",
    [Constants.WS_CODE_GET_RACE_DAY_INFO_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_GET_RACE_DAY_INFO_RESPONSE]: "RaceCards",
    [Constants.WS_CODE_BROADCAST_DISCUSSION]: "Comments",
    [Constants.WS_CODE_BROADCAST_HOT_NEWS]: "HotNewsList",
    [Constants.WS_CODE_BROADCAST_PERSONAL_TIPS]: "PersonalRaceTips",
    [Constants.WS_CODE_BROADCAST_RACE_STARTED]: "RaceCard",
    [Constants.WS_CODE_BROADCAST_RACE_ENDED]: "RaceCard",
    [Constants.WS_CODE_UPDATE_USER_BIOGRAPHY_REQUEST]: "UserProfile",
    [Constants.WS_CODE_UPDATE_USER_BIOGRAPHY_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_IN_APP_PURHCASE_REQUEST]: "PurchaseInfo",
    [Constants.WS_CODE_IN_APP_PURCHASE_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_UPDATE_NOTIFICATION_PREFERENCE_REQUEST]: "UserProfile",
    [Constants.WS_CODE_UPDATE_NOTIFICATION_PREFERENCE_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_BLOCK_RACE_COMMENT_REQUEST]: "Comment",
    [Constants.WS_CODE_BLOCK_RACE_COMMENT_RESPONSE]: "Comment",
    [Constants.WS_CODE_BROADCAST_BLOCK_RACE_COMMENT]: "Comment",
    [Constants.WS_CODE_BUY_TIPS_BY_IAP_REQUEST]: "PurchaseInfo",
    [Constants.WS_CODE_BUY_TIPS_BY_IAP_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_CHECK_TIPS_PURCHASED_REQUEST]: "RaceTip",
    [Constants.WS_CODE_CHECK_TIPS_PURCHASED_RESPONSE]: "RaceTip",
    [Constants.WS_CODE_CREATE_PACKAGE_TIPS_REQUEST]: "TipsPackage",
    [Constants.WS_CODE_CREATE_PACKAGE_TIPS_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_PUBLISH_PACKAGE_TIPS_REQUEST]: "TipsPackage",
    [Constants.WS_CODE_PUBLISH_PACKAGE_TIPS_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_PACKAGE_TIPS_REQUEST]: "RaceTip",
    [Constants.WS_CODE_GET_PACKAGE_TIPS_RESPONSE]: "RaceCards",
    [Constants.WS_CODE_GET_LATEST_PACKAGE_TIPS_REQUEST]: "TipsterInfo",
    [Constants.WS_CODE_GET_LATEST_PACKAGE_TIPS_RESPONSE]: "TipsPackages",
    [Constants.WS_CODE_EDIT_PACKAGE_TIPS_REQUEST]: "TipsPackage",
    [Constants.WS_CODE_EDIT_PACKAGE_TIPS_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_BROADCAST_TIPS_PACKAGE_COMMENT]: "Comments",
    [Constants.WS_CODE_PING_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_PING_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_CREDIT_CARD_INFO_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_GET_CREDIT_CARD_INFO_RESPONSE]: "CreditCard",
    [Constants.WS_CODE_UPDATE_TIPS_PACKAGE_PRICE_REQUEST]: "FbTipsterInfo",
    [Constants.WS_CODE_UPDATE_TIPS_PACKAGE_PRICE_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_DELETE_CREDIT_CARD_REQUEST]: "CreditCard",
    [Constants.WS_CODE_DELETE_CREDIT_CARD_RESPONSE]: "RespInfo",



    [Constants.WS_CODE_GET_USER_REQUEST]: "UserProfile",
    [Constants.WS_CODE_GET_USER_RESPONSE]: "UserProfile",
    [Constants.WS_CODE_GET_MATCH_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_GET_MATCH_RESPONSE]: "FbMatchDays",
    [Constants.WS_CODE_GET_FB_TIPSTERS_REQUEST]: "UserProfile",
    [Constants.WS_CODE_GET_FB_TIPSTERS_RESPONSE]: "FbTipsters",
    [Constants.WS_CODE_ADD_FB_COMMENT_REQUEST]: "Comment",
    [Constants.WS_CODE_ADD_FB_COMMENT_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_FB_COMMENT_REQUEST]: "Comment",
    [Constants.WS_CODE_GET_FB_COMMENT_RESPONSE]: "Comments",
    [Constants.WS_CODE_BROADCAST_FB_COMMENT]: "Comments",
    [Constants.WS_CODE_BROADCAST_BLOCKED_FB_COMMENT]: "Comment",
    [Constants.WS_CODE_BLOCK_FB_COMMENT_REQUEST]: "Comment",
    [Constants.WS_CODE_BLOCK_FB_COMMENT_RESPONSE]: "Comment",
    [Constants.WS_CODE_GET_FB_MATCH_DETAIL_REQUEST]: "FbMatch",
    [Constants.WS_CODE_GET_FB_MATCH_DETAIL_RESPONSE]: "FbMatch",
    [Constants.WS_CODE_ADD_FB_TIPS_REQUEST]: "FbTip",
    [Constants.WS_CODE_ADD_FB_TIPS_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_FB_PERSONAL_TIPS_REQUEST]: "FbMatch",
    [Constants.WS_CODE_GET_FB_PERSONAL_TIPS_RESPONSE]: "FbPersonalTips",
    [Constants.WS_CODE_BUY_FB_TIPS_REQUEST]: "FbTip",
    [Constants.WS_CODE_BUY_FB_TIPS_RESPONSE]: "FbTip",
    [Constants.WS_CODE_ADD_FB_TIPS_COMMENT_REQUEST]: "Comment",
    [Constants.WS_CODE_ADD_FB_TIPS_COMMENT_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_FB_TIPS_COMMENT_REQUEST]: "Comment",
    [Constants.WS_CODE_GET_FB_TIPS_COMMENT_RESPONSE]: "Comments",
    [Constants.WS_CODE_BROADCAST_FB_TIPS_COMMENT]: "Comments",
    [Constants.WS_CODE_GET_FB_TIPSTER_LATEST_RESULT_REQUEST]: "FbTipsterInfo",
    [Constants.WS_CODE_GET_FB_TIPSTER_LATEST_RESULT_RESPONSE]: "FbMatchDay",
    [Constants.WS_CODE_GET_FB_TIPSTER_INFO_REQUEST]: "FbTipsterInfo",
    [Constants.WS_CODE_GET_FB_TIPSTER_INFO_RESPONSE]: "FbTipsterInfo",
    [Constants.WS_CODE_ADD_FAVOURITE_REQUEST]: "FbMatch",
    [Constants.WS_CODE_ADD_FAVOURITE_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_FAVOURITE_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_GET_FAVOURITE_RESPONSE]: "FbMatchDay",
    [Constants.WS_CODE_GET_BET_AMOUNT_QUOTA_REQUEST]: "FbMatch",
    [Constants.WS_CODE_GET_BET_AMOUNT_QUOTA_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_FB_TIPS_DETAILS_REQUEST]: "FbTip",
    [Constants.WS_CODE_GET_FB_TIPS_DETAILS_RESPONSE]: "FbTip",
    [Constants.WS_CODE_SUBSCRIBE_FB_TIPSTER_REQUEST]: "TipsterSubscribeReqInfo",
    [Constants.WS_CODE_SUBSCRIBE_FB_TIPSTER_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_FB_TRANSACTIONS_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_GET_FB_TRANSACTIONS_RESPONSE]: "Transactions",
    [Constants.WS_CODE_GET_FB_ACTIVITIES_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_GET_FB_ACTIVITIES_RESPONSE]: "ActivityList",
    [Constants.WS_CODE_GET_RACE_HORSE_NOTES_REQUEST]: "RaceCard",
    [Constants.WS_CODE_GET_RACE_HORSE_NOTES_RESPONSE]: "RaceCard",
    [Constants.WS_CODE_GET_TIPS_PACKAGE_DETAILS_REQUEST]: "FbTipsPackage",
    [Constants.WS_CODE_GET_TIPS_PACKAGE_DETAILS_RESPONSE]: "FbTipsPackage",
    [Constants.WS_CODE_BUY_TIPS_PACKAGE_REQUEST]: "FbTipsPackage",
    [Constants.WS_CODE_BUY_TIPS_PACKAGE_RESPONSE]: "FbTipsPackage",
    [Constants.WS_CODE_ADD_FB_TIPS_PACKAGE_NOTES_REQUEST]: "FbTipsPackage",
    [Constants.WS_CODE_ADD_FB_TIPS_PACKAGE_NOTES_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_BROADCAST_TIPS_COMMENT]: "Comments",
    [Constants.WS_CODE_GET_NEW_BUY_TIPS_REQUEST]: "RaceTip",
    [Constants.WS_CODE_GET_NEW_BUY_TIPS_RESPONSE]: "RaceTip",
    [Constants.WS_CODE_NOTIFY_BUYERS_TIPS_PACKAGE_UPDATED_REQUEST]: "TipsPackage",
    [Constants.WS_CODE_NOTIFY_BUYERS_TIPS_PACKAGE_UPDATED_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_BROADCAST_HORSE_TIPS_REMINDER]: "RaceCard",
    [Constants.WS_CODE_QUERY_UNION_PAY_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_QUERY_UNION_PAY_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_NOTIFY_BUYERS_FB_TIPS_PACKAGE_UPDATED_REQUEST]: "FbTip",
    [Constants.WS_CODE_NOTIFY_BUYERS_FB_TIPS_PACKAGE_UPDATED_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_CLAIM_REWARD_REQUEST]: "RaceTip",
    [Constants.WS_CODE_CLAIM_REWARD_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_BROADCAST_RADIO]: "RespInfo",
    [Constants.WS_CODE_LOG_LIVE_STREAMING_REQUEST]: "UserProfile",
    [Constants.WS_CODE_LOG_LIVE_STREAMING_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_GET_VIDEO_INFO_REQUEST]: "UserProfile",
    [Constants.WS_CODE_GET_VIDEO_INFO_RESPONSE]: "Tipsters",
    [Constants.WS_CODE_FB_GET_VIDEO_INFO_REQUEST]: "UserProfile",
    [Constants.WS_CODE_FB_GET_VIDEO_INFO_RESPONSE]: "FbMatchDays",
    [Constants.WS_CODE_BROADCAST_RECEIVE_VOUCHER]: "HotNews",
    [Constants.WS_CODE_GET_TIPSTER_ARTICLE_REQUEST]: "UserProfile",
    [Constants.WS_CODE_GET_TIPSTER_ARTICLE_RESPONSE]: "Tipsters",
    [Constants.WS_CODE_GET_BF_TIPSTER_ARTICLE_REQUEST]: "UserProfile",
    [Constants.WS_CODE_GET_BF_TIPSTER_ARTICLE_RESPONSE]: "FbMatchDays",
    [Constants.WS_CODE_GET_ALL_ARTICLE_DETAILS_REQUEST]: "UserProfile",
    [Constants.WS_CODE_GET_ALL_ARTICLE_DETAILS_RESPONSE]: "Tipsters",
    [Constants.WS_CODE_GET_ARTICLE_DETAILS_REQUEST]: "RaceTip",
    [Constants.WS_CODE_GET_ARTICLE_DETAILS_RESPONSE]: "RaceCard",
    [Constants.WS_CODE_GET_VIDEO_AND_ARTICLE_REQUEST]: "UserProfile",
    [Constants.WS_CODE_GET_VIDEO_AND_ARTICLE_RESPONSE]: "Tipsters",
    [Constants.WS_CODE_UPDATE_ANALYSIS]: "RespInfo",
    [Constants.WS_CODE_GET_SPEED_ARTICLE_REQUEST]: "RaceCard",
    [Constants.WS_CODE_GET_SPEED_ARTICLE_RESPONSE]: "RespInfo",
    [Constants.WS_CODE_QUERY_VISA_MASTER_REQUEST]: "LanguageParam",
    [Constants.WS_CODE_QUERY_VISA_MASTER_RESPONSE]: "RespInfo",

    [Constants.WS_CODE_DISABLE_ACCOUNT_REQUEST]: "UserProfile",
    [Constants.WS_CODE_DISABLE_ACCOUNT_RESPONSE]: "RespInfo",

  };

  static isEnglish() {
    return Constants.LANG_NAME == Constants.LANG_EN;
  }

}


/*
  HAD = 主客和
  FHAD = 半場主客和
  HHAD = 讓球主客和
  HDC = 讓球
  HILO = 入球大細
  FHILO = 半場入球大細
  CHLO = 角球大細
*/
export enum FbBetType {
  HAD,
  FHAD,
  HHAD,
  HDC,
  HILO,
  FHILO,
  CHLO,
  HAFU
};

export enum FbBetItemOption {
  None,
  Hi,
  Lo,
  Home,
  Draw,
  Away,
  HomeHome,
  HomeDraw,
  HomeAway,
  DrawHome,
  DrawDraw,
  DrawAway,
  AwayHome,
  AwayDraw,
  AwayAway
}
export enum TipAssociateType { SystemAssigned, Subscribed, Followed, LuckStar, HighestScore, GoodTipToday, GoodTipLastRace, FollowedPackage, PublishedPackage}

export enum NewsAssociateType {NewsType_HouseNews, NewsType_CongratPrevRacePaidTipsWon, NewsType_FollowedTipstersWon, NewsType_RecommendedTipsWon,
NewsType_PromoTopTipstersPrevRace, NewsType_SubscribedTipsComing,
NewsType_FollowedTipsComing, NewsType_HouseRaceComment, NewsType_TopTipstersRaceComment, NewsType_RemindNotedHorse,
NewsType_RemindPublishTips, NewsType_AnnounceTopTipstersBeforeRaces, NewsType_AnnounceTopTipstersAfterRaces,
NewsType_PromoteUnrelatedTipsters, NewsType_RemindNotedHorsePreRaceDay, NewsType_RemindUseRacingNoteAfterRaces,
NewsType_RemindUseAppNextRace, NewsType_RemindShareFriends, NewsType_RemindLowBalance, NewsType_UserTipsWon,
NewsType_HorseTipsPackageNews, NewsType_FbTipsPackageNews, NewsType_HorseReward, NewsType_FbReward};

export enum ConfidenceLevel { ConfidenceLevel_Try, ConfidenceLevel_Good, ConfidenceLevel_Strong };

export enum RaceSeason { RaceReason_Y2015_16, RaceReason_Y2016_17, RaceReason_Y2017_18, RaceReason_Y2018_19, RaceReason_Y2019_20, RaceReason_Y2020_21, RaceReason_Y2021_22, RaceReason_Y2022_23, RaceReason_Y2023_24, RaceReason_Y2024_25, RaceReason_Y2025_26 };

export enum RaceCourse { RaceCourse_Shatin, RaceCourse_HappyValley, RaceCourse_CongHua };

export enum RaceTrack { RaceTrack_AllWeather, RaceTrack_A, RaceTrack_A2, RaceTrack_A3, RaceTrack_B, RaceTrack_B2, RaceTrack_B3, RaceTrack_C, RaceTrack_C3, RaceTrack_NA, RaceTrack_NA2, RaceTrack_NB, RaceTrack_NB2 };

export enum RaceTrackShort { RaceTrack_AllWeather_Short, RaceTrack_A_Short, RaceTrack_A2_Short, RaceTrack_A3_Short, RaceTrack_B_Short, RaceTrack_B2_Short, RaceTrack_B3_Short, RaceTrack_C_Short, RaceTrack_C3_Short, RaceTrack_NA_Short, RaceTrack_NA2_Short, RaceTrack_NB_Short, RaceTrack_NB2_Short };

export enum TrackCondition { TrackCondition_T_Firm, TrackCondition_T_GoodToFirm, TrackCondition_T_Good, TrackCondition_T_GoodToYielding, TrackCondition_T_Yielding, TrackCondition_T_YieldingToSoft, TrackCondition_T_Soft, TrackCondition_T_Heavy, TrackCondition_AW_WetFast, TrackCondition_AW_Fast, TrackCondition_AW_Good, TrackCondition_AW_Slow, TrackCondition_AW_WetSlow, TrackCondition_AW_RainAffected, TrackCondition_AW_NormalWatering, TrackCondition_Not_Available };

export enum RaceDistance { RaceDistance_STT1000, RaceDistance_STT1200, RaceDistance_STT1400, RaceDistance_STT1600, RaceDistance_STT1800, RaceDistance_STT2000, RaceDistance_STT2200, RaceDistance_STT2400, RaceDistance_HVT1000, RaceDistance_HVT1200, RaceDistance_HVT1650, RaceDistance_HVT1800, RaceDistance_HVT2200, RaceDistance_HVT2400, RaceDistance_STA1200, RaceDistance_STA1650, RaceDistance_STA1800, RaceDistance_STA2000, RaceDistance_STA2400 };

export enum RaceClass { RaceClass_G1International, RaceClass_G2International, RaceClass_G3International, RaceClass_G1, RaceClass_G2, RaceClass_G3, RaceClass_Class1, RaceClass_Class2, RaceClass_Class3, RaceClass_Class4, RaceClass_Class5, RaceClass_Restricted, RaceClass_Griffins, RaceClass_Others, RaceClass_FourYearsOld, RaceClass_TwoYearsOld, RaceClass_TwoThreeYearsOld, RaceClass_ThreeYearsOld, RaceClass_ThreeFourYearsOld, RaceClass_ThreeYearsOldUp, RaceClass_FourYearsOldUp, RaceClass_FiveYearsOld };

export enum RaceClassShort { RaceClass_G1International_Short, RaceClass_G2International_Short, RaceClass_G3International_Short, RaceClass_G1_Short, RaceClass_G2_Short, RaceClass_G3_Short, RaceClass_Class1_Short, RaceClass_Class2_Short, RaceClass_Class3_Short, RaceClass_Class4_Short, RaceClass_Class5_Short, RaceClass_Restricted_Short, RaceClass_Griffins_Short, RaceClass_Others_Short, RaceClass_FourYearsOld_Short, RaceClass_TwoYearsOld_Short, RaceClass_TwoThreeYearsOld_Short, RaceClass_ThreeYearsOld_Short, RaceClass_ThreeFourYearsOld_Short, RaceClass_ThreeYearsOldUp_Short, RaceClass_FourYearsOldUp_Short, RaceClass_FiveYearsOld_Short };

export enum QQPStrategy { QQPStrategy_None, QQPStrategy_Q, QQPStrategy_QP, QQPStrategy_QQP, QQPStrategy_Q1QP2, QQPStrategy_Q1QP3, QQPStrategy_Q1QP5, QQPStrategy_Q2QP1, QQPStrategy_Q3QP1, QQPStrategy_Q5QP1 };

export enum WpStrategy { WPStrategy_None, WPStrategy_Win, WPStrategy_Place, WPStrategy_WinPlace, WPStrategy_Win1Place2, WPStrategy_Win1Place3, WPStrategy_Win1Place5, WPStrategy_Win2Place1, WPStrategy_Win3Place1, WPStrategy_Win5Place1 };

export enum RacingNoteOption { RacingNoteOption_StartBlocked, RacingNoteOption_StartSlow, RacingNoteOption_DrawIssue, RacingNoteOption_TurningIssue, RacingNoteOption_Collision, RacingNoteOption_RunningIssue, RacingNoteOption_JockeyIssue, RacingNoteOption_Accident, RacingNoteOption_HurtSick, RacingNoteOption_GiveUp };

export enum WPStrategiesChoice { "None", "W", "P", "WP", "1W2P", "1W3P", "1W5P", "2W1P", "3W1P", "5W1P" };

export enum QQPStrategiesChoice { "None", "Q", "QP", "QQP", "1Q2QP", "1Q3QP", "1Q5QP", "2Q1QP", "3Q1QP", "5Q1QP" };

export enum WPStrategiesChoiceLangKey {
  "WPStrategy_None",
  "WPStrategy_Win",
  "WPStrategy_Place",
  "WPStrategy_WinPlace",
  "WPStrategy_Win1Place2",
  "WPStrategy_Win1Place3",
  "WPStrategy_Win1Place5",
  "WPStrategy_Win2Place1",
  "WPStrategy_Win3Place1",
  "WPStrategy_Win5Place1"
}

export enum QQPStrategiesChoiceLangKey {
    "QQPStrategy_None",
    "QQPStrategy_Q",
    "QQPStrategy_QP",
    "QQPStrategy_QQP",
    "QQPStrategy_Q1QP2",
    "QQPStrategy_Q1QP3",
    "QQPStrategy_Q1QP5",
    "QQPStrategy_Q2QP1",
    "QQPStrategy_Q3QP1",
    "QQPStrategy_Q5QP1"
}

export enum TipsStatus {TipsStatusNotCreated, TipsStatusDrafted, TipsStatusPublished};

export enum FollowStatus {None, Followed, Subscribed}

export enum VerifyStatus {Pending, Rejected, Completed}

export enum CashoutStatus {Pending, Rejected, Processing, Completed}

export enum BankInStatus {bankInStatusProcessing, bankInStatusRejected, bankInStatusCompleted}

export enum TipsPackageView { Match, TipsPackage }

export enum HorseRankingView { InRace, TipsPackage}

export enum FunctionType { Horse, Football, Help}

export enum RedirectLinkType { FaqHorse, FaqFootball, Wins, FootballContest, HorseContest, Facebook, Youtube, Homepage}

export enum HorseRankingType { Score, Profitability, Accuracy}

export enum CreditCard { VisaMaster, UnionPay }
export enum MatchProgress { NotStarted, FirstHalf, HalfTime, SecondHalf, Ended, Started,Voided}

export enum ShareType {  HorseInRace = 8, HorseTipsPackage = 9, FbTipsPackage =10}



// WEBPACK FOOTER //
// ./src/util/Constants.ts